import React from 'react';
import { useAuth } from '../AuthContext'; // Import useAuth to access logout function

const Dashboard = () => {
  const { logout } = useAuth(); // Access the logout function from context

  return (
    <div className="dashboard-container">
      <div>
        <h2>Welcome to the Dashboard</h2>
        <p>Content for the dashboard goes here.</p>
      </div>
      
      {/* Logout Button Container */}
      {/*<div className="logout-button-container">
        <button onClick={logout} className="logout-button">Logout</button> 
      </div>
      */}
    </div>
  );
};

export default Dashboard;
